 import './index.scss'
 const ToolbarItem: React.FC<{
  icon?: string;
  title: string;
  onClick: () => void;
  iconDom?: React.ReactNode;
}> = ({ icon, title, onClick, iconDom }) => {
  return (
    <div 
      className="toolbar-item flex flex-col items-center text-[#000] hover:text-[#3355FF] justify-center w-60px h-60px gap-[6px] rounded-lg cursor-pointer"
      onClick={onClick}
    >
      {
        iconDom ?  iconDom : <img src={icon} alt="" className="size-20px"/>
      }
      <span className="text-12px">{title}</span>
    </div>
  );
};
export default ToolbarItem;
